var _ = require('lodash');
global.$ = require('jquery');
var Rectangle = require('paths-js/rectangle');

let handler = function(e){
  let tok_id = e.target.id;
  let doc_id = tok_id.replace(/_[0-9]{1,}$/, "");
  let keys = Object.keys(toks[doc_id]);
  let dd = document.querySelectorAll('[data-passage="' + doc_id + '"]');

  //*get the highest + lowest col numbers */
  let mx = _.minBy(dd, function(o) {
    return parseInt(o.getAttribute("data-colno"));
  });
  let min_c = mx.getAttribute("data-colno");
  mx = _.maxBy(dd, function(o) {
    return parseInt(o.getAttribute("data-colno"));
  });
  let max_c = mx.getAttribute("data-colno");
  mx = _.minBy(dd, function(o) {
    return parseInt(o.getAttribute("data-rowno"));
  });
  let min_r = parseInt(mx.getAttribute("data-rowno"));
  mx = _.maxBy(dd, function(o) {
    return parseInt(o.getAttribute("data-rowno"));
  });
  let max_r = parseInt(mx.getAttribute("data-rowno"));

  $(".tmp").remove(); //remove old lines

  var draw_row = function draw_row(rn, cl, dd){
    let found = false;
    let rr = _(dd).forEach(function(v) {
      var ptcl = parseInt(v.getAttribute("data-colno"));
      var ptrw = parseInt(v.getAttribute("data-rowno"));
      if (ptcl == cl){
        //rn is not the actual row number of clicked, it is row number
        //plus one or minus one
        if (ptrw == (rn)){
          found = true; //i.e. there is a row below
          // console.log(ptrw, rn);
          return found;
        }
      }
    });
    return found;
  };

  var draw_col = function draw_row(rn, cl, dd){
    let found = false;
    let rr = _(dd).forEach(function(v) {
      var ptcl = parseInt(v.getAttribute("data-colno"));
      var ptrw = parseInt(v.getAttribute("data-rowno"));
      if (ptrw == (rn)){
        //cl is not the actual col number of clicked, it is col number
        //plus one or minus one
        if (ptcl == cl){
          found = true; //i.e. there is a row below
          // console.log(ptrw, rn);
          return found;
        }
      }
    });
    return found;
  };

  //add horizontal lines. remember that w/ svg the y value measures distance from top of scv
  //horizontal lines at the bottom
  _(dd).forEach(function(v) {
    let found = draw_row(parseInt(v.getAttribute("data-rowno")) + 1, parseInt(v.getAttribute("data-colno")), dd);
    //console.log(show_line);
    if (found == false){
        var svg = document.getElementsByTagName('svg')[0]; //Get svg element
        var newElement = document.createElementNS("http://www.w3.org/2000/svg", 'path');
        var ll = "M " + parseInt(v.getAttribute("data-left")) + " " + parseInt(v.getAttribute("data-top")) + " L " + parseInt(v.getAttribute("data-right")) + " " + parseInt(v.getAttribute("data-top"));
        newElement.setAttribute("d", ll); //Set path's data
        newElement.setAttribute("class", "tmp");
        newElement.style.stroke = "#000"; //Set stroke colour
        newElement.style.strokeWidth = "1px"; //Set stroke width
        svg.appendChild(newElement);
    };
  });

  //horizontal lines at the top
  _(dd).forEach(function(v) {
    let found = draw_row(parseInt(v.getAttribute("data-rowno")) - 1, parseInt(v.getAttribute("data-colno")), dd);
    if (found == false){
        var svg = document.getElementsByTagName('svg')[0]; //Get svg element
        var newElement = document.createElementNS("http://www.w3.org/2000/svg", 'path');
        var ll = "M " + parseInt(v.getAttribute("data-left")) + " " + parseInt(v.getAttribute("data-bottom")) + " L " + parseInt(v.getAttribute("data-right")) + " " + parseInt(v.getAttribute("data-bottom"));
        newElement.setAttribute("d", ll); //Set path's data
        newElement.setAttribute("class", "tmp");
        newElement.style.stroke = "#000"; //Set stroke colour
        newElement.style.strokeWidth = "1px"; //Set stroke width
        svg.appendChild(newElement);
    };
  });



  //vertical lines to the right
  _(dd).forEach(function(v) {
    let found = draw_row(parseInt(v.getAttribute("data-rowno")), parseInt(v.getAttribute("data-colno")) + 1, dd);
    if (found == false){
        var svg = document.getElementsByTagName('svg')[0]; //Get svg element
        var newElement = document.createElementNS("http://www.w3.org/2000/svg", 'path');
        var ll = "M " + parseInt(v.getAttribute("data-right")) + " " + parseInt(v.getAttribute("data-top")) + " L " + parseInt(v.getAttribute("data-right")) + " " + parseInt(v.getAttribute("data-bottom"));
        newElement.setAttribute("d", ll); //Set path's data
        newElement.setAttribute("class", "tmp");
        newElement.style.stroke = "#000"; //Set stroke colour
        newElement.style.strokeWidth = "1px"; //Set stroke width
        svg.appendChild(newElement);
    };
  });

  //vertical lines to the left
  _(dd).forEach(function(v) {
    let found = draw_row(parseInt(v.getAttribute("data-rowno")), parseInt(v.getAttribute("data-colno")) - 1, dd);
    if (found == false){
        var svg = document.getElementsByTagName('svg')[0]; //Get svg element
        var newElement = document.createElementNS("http://www.w3.org/2000/svg", 'path');
        var ll = "M " + parseInt(v.getAttribute("data-left")) + " " + parseInt(v.getAttribute("data-top")) + " L " + parseInt(v.getAttribute("data-left")) + " " + parseInt(v.getAttribute("data-bottom"));
        newElement.setAttribute("d", ll); //Set path's data
        newElement.setAttribute("class", "tmp");
        newElement.style.stroke = "#000"; //Set stroke colour
        newElement.style.strokeWidth = "1px"; //Set stroke width
        svg.appendChild(newElement);
    };
  });

  var i;
  //var toks = TRACKER["passage_to_toks"][doc_id];
  var colored_toks = TRACKER["passage_to_toks"][doc_id];
  var all_toks = toks[doc_id];
  //todo: string overlap == same tok. no real tok ordering yet.
  //not sure if there is any way to do that
  var out = "";
  let cwords = {};
  for (i = 0; i < Object.keys(colored_toks).length; i++){
    let color = phi(TRACKER[colored_toks[i]]);
    let cword = TRACKER["words"][colored_toks[i]];
    cwords[cword] = color;
  }
  out = "";
  let last = 0;
  for (i = 0; i < Object.keys(all_toks).length; i++){
    let word = all_toks[i]["tok"];
    let offset = all_toks[i]["offset"];
    let color = cwords[word.toLowerCase()];
    if (color == "undefined"){
      color = "black";
    }
    if (offset[0] > last){
      word = " " + word;
    }
    out = out + "<span style='color:" + color + "'>" + word + "</span>";
    last = offset[1];
  }
  $("#deets").html(out);
  
  $("#passage").html(doc_id.replace("_", ", section "));
}

global.sb = function setup_boxes(tracker_) {
      let ee = tracker_["tok_no_map"];

      let n_big_cols;
      let col_gap_px;
      //sort of iffy attempt to make this sort of responsive
      if($(window).width() > 992){
        n_big_cols = 40;
        col_gap_px = 18; // how many px bween the cols?
      }else if ($(window).width() > 768) {
        n_big_cols = 35;
        col_gap_px = 20; // how many px bween the cols?
      }else{
        n_big_cols = 30;
        col_gap_px = 10; // how many px bween the cols?
      }

      let mini_row_length = 5;


      let big_cols = _.chunk(_.range(0, Object.keys(ee).length), Object.keys(ee).length/n_big_cols);
      let tok_per_minicol = Math.ceil(big_cols[0].length/mini_row_length);

      let tok_side = window.svgh / tok_per_minicol;

      let submitter = function(i, j){
          URL = "context?id=" + i;
          $.getJSON(URL,function(d){
            this.setState({deets: d["d"], sel_tokens: d["t"]});
          }.bind(this));
      }.bind(this);
      var out = "";
      var big_cols_svg = big_cols.map(function(tokens_in_col, col_no){
              let mini_row_accross = mini_row_length;
              let tmp_where = _.chunk(tokens_in_col, mini_row_accross);
              return tmp_where.map(function(mini_row, mini_row_no){  // for each minirow
                  return mini_row.map(function(token, tok_no){
                    var bottom_ = tok_side * mini_row_no;
                    var top_ = bottom_ + tok_side;
                    var left_ = tok_no * tok_side + (col_no * col_gap_px);
                    var right_ = left_ + tok_side;
                    var tok_svg = Rectangle({
                                            top: top_,
                                            bottom: bottom_,
                                            left: left_,
                                            right: right_
                                            });
                    var tok_path = tok_svg.path.print();
                    var tok_color = COLORS[Math.random() * (0 - 11)];
                    var semantic_id = tracker_["tok_no_to_semantic_id"][token];
                    let doc_id = semantic_id.replace(/_[0-9]{1,}$/, "");
                    out = out + "<path data-word='" + tracker_["words"][semantic_id] + "' data-right='" + right_ + "' data-left='" + left_ + "' data-bottom='" + bottom_ + "' data-top='" + top_ + "' data-passage='" + doc_id + "' data-colno='" + tok_no + "' data-rowno='" + mini_row_no + "'class='pixel' id='" + semantic_id + "' d='" + tok_path + "' stroke='grey' stroke-width='1' stroke-opacity='.3' fill-opacity='1' fill='" + tok_color + "' />";
                 }.bind(this));
              }.bind(this));
      }.bind(this));
    $("#ex").html(out);
    $(".pixel").click(handler);
}


//global.COLORS = ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00"]

global.COLORS = ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"]


global.phi = function phi(count_dict){

    let max_v = 0;
    let max_k = 0;

    Object.keys(count_dict).map(function(e) {
                                    if (count_dict[e] > max_v){
                                      max_v = count_dict[e];
                                      max_k = e;
                                    }
                                    return "NA";
                            });

    return COLORS[max_k];
}
